import { BlocksIconMessage } from 'blocks-nextjs/blocks-web-components/components/icon/icons/message';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconMessage = createComponent({ react: React, tagName: 'cat-icon-message', elementClass: BlocksIconMessage });
